/*
 * Site-wide loader. Previously a jQuery UI modal on #aerobilet_loader, which
 * blocked the whole screen; now delegates to the shared non-blocking
 * IATILoader. The serviceType argument is kept so the 180-odd existing call
 * sites need no change.
 */
var aerobilet_overlay = {
	show : function(serviceType) {
		if (serviceType == "Hotel") {
			IATILoader.showKey('js.loading.hotel.text', 'js.search.loading.process');
		} else {
			IATILoader.showKey('js.search.loading.process');
		}
	},
	hide : function() { IATILoader.hide(); }
};

function openLoaderBox(serviceType) {
	aerobilet_overlay.show(serviceType);
}

function closeLoaderBox() {
	aerobilet_overlay.hide();
}

function fillCountries(){
	$.ajax({
		url : "/jCountries",
		dataType : "json",
		async : false,
		success : function(data) {
			if (data != null) {
				var countriesOptions = "<option value=''>" + FmtMessage.getMessage('js.person.chooseCountry') + "</option>";

				$(data.countries).each(function(index, country) {
					countriesOptions += "<option value='" + country.code + "' data-title='" + country.country + "' data-image='/images/msdropdown/icons/blank.gif' data-imagecss='flag " + country.code + "' >" + country.country + "</option>";
				});

				$("[iType=fillCountry]").html(countriesOptions);
			}
		}
	});
}
var _globalCurrenyIcon='';
var siteCurrencies = {
	    'USD': '$', 
	    'EUR': '€',
	    'GBP': '£',
	    'TL' : '₺',
	    'TRY' : '₺',
	    'INR': '₹',
	    'UAH': '₴',
	    'ILS': '₪',
	    'EGP': '£',
        'SAR': '﷼',
        'BDT': '৳',
        'QAR': '﷼',
        'RUB': '₽',
        'CHF': '₣',
        'PLN': 'zł',
        'PKR': '',
        'AED': 'د.إ',
        'AZN': '₼',
        'IDH': '',
        'KWD': 'ك',
		'OMR': 'ريال',
		'IQD': 'دينار',
		'KES': 'KSh',
		'DZD': 'DZ'
	};

function getSiteCurrencyIcon(){
	if(_globalCurrenyIcon=='') {
	  try 
  	  {
        var localCur = $.cookie('currency');
        if(typeof siteCurrencies[localCur]!=='undefined') {
	       var res= siteCurrencies[localCur];
	        if (typeof res!=='undefined' ) _globalCurrenyIcon= res; 
	     }
     	}
	  catch(err) {
	    return _result='' ;
	  }
	}
	return _globalCurrenyIcon;
}
function numberFormat(num,digit) {
	var _digit=  (typeof digit =='undefined')? 0:digit;  
	if(Math.round(num) == num) _digit=0;
	return (
		  Number(num)
	      .toFixed(_digit) 
	      .replace('.', ',') 
	      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') 
	  )
}
function currencyFormat(num)
{
  return numberFormat(num,2) +' '+getSiteCurrencyIcon();	
}

function currencyFormatZero(num)
{
  return numberFormat(num,0) +' '+getSiteCurrencyIcon();	
}

function isNullOrEmpty(string) {
	if (typeof string != 'string'){
		return true;
	}
	else if (string.length == 0){
		return true;
	}

	return false;
}

// mobileNav scrollJump Function //
function scrollJump(){
	var el = document.querySelector(".search-nav");
	
	var scrollVal = el.scrollLeft;
	if( scrollVal > 0 ){
		el.style.marginLeft = 0;
	}
}

